export default "__VITE_ASSET__CUJW9HHA__"